import HeroBg from "public/cloudMigration/k8ToPaas.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Modernize Your Platform Stack ",
    link: "contact-us",
  },
  desc: "Migrate any K8s environment to OneMind PaaS — a fully managed, secure platform built on open standards, backed by built-in observability, compliance, and developer-ready automation. ",
  title: "Bring Your Kubernetes. We’ll Handle the Rest. ",
  image: HeroBg,
};
